import { Map } from 'immutable';
import { actions } from '../constants';
import cookie from 'react-cookie';

export function start() {
  const session = cookie.load('session');
  return {
    type: actions.LOAD_SESSION,
    payload: {
      sessionToken: session && session.token,
      account: session && Map(session.user)
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/app.js